import styled from 'styled-components';
import { TooltipTemplate } from './TooltipTemplate';

export const TooltipStyled = styled(TooltipTemplate)`
    .tooltip-box {
        z-index: 100000 !important;
    }
`;
